import type { SystemStyleObject, ThemingProps } from '@chakra-ui/react'
import { Link as ChakraLink, Icon, Text } from '@chakra-ui/react'
import { faLinkHorizontal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link as ReactRouterLink } from 'react-router'

import { useAuth } from '@/context/AuthContext'

interface UserLinkProps extends ThemingProps {
  userId?: string
  firstName?: string
  lastName?: string
  name?: string
  sx?: SystemStyleObject
}

export const UserLink = ({ userId, firstName, lastName, name, ...rest }: UserLinkProps) => {
  const { user } = useAuth()

  const displayName = firstName && lastName ? `${lastName} ${firstName}` : name

  if (!user?.allowDisplayOrganizationStructure || !userId) {
    return <Text as='span' {...rest}>{displayName}</Text>
  }

  return <ChakraLink as={ReactRouterLink} to={`/user/${userId}`} {...rest} sx={{ whiteSpace: 'nowrap', color: 'primary.500', ...rest.sx }}>
    {displayName}
    <Icon
      as={FontAwesomeIcon}
      icon={faLinkHorizontal}
      ml={1.5}
      opacity={0.5}
      {...rest}
    />
  </ChakraLink>
}